import Component from '../core/Component'
import Scroll, {getScroll} from '../services/Scroll'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'
import { CMS } from '../core/config'

export const STATES = {
    ACTIVE: 'is-active',
    IS_LIGHT: 'is-light'
}

export default class FullModalToggle extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        EventBus.on('fullmodal:open', this.handleModalOpen)
        EventBus.on('fullmodal:close', this.handleModalClose)
        EventBus.on('section:enter', this.handleSectionEnter)

        if (!CMS) {
            this.element.addEventListener('click', this.handleClick)
        }
    }

    destroy() {
        EventBus.off('fullmodal:open', this.handleModalOpen)
        EventBus.off('fullmodal:close', this.handleModalClose)
        EventBus.off('section:enter', this.handleSectionEnter)
    }

    handleSectionEnter = ({ dark }) => {
        toggleClass(this.element, STATES.IS_LIGHT, dark)
    }

    handleModalOpen = ({ id }) => {
        if (id !== this.element.dataset.id) {
            return
        }

        this.element.classList.add(STATES.ACTIVE)
    }

    handleModalClose = ({ id }) => {
        if (id !== this.element.dataset.id) {
            return
        }

        this.element.classList.remove(STATES.ACTIVE)
    }

    handleClick = event => {
        event.preventDefault()
        const nav = Component.getFromElement(this.element.dataset.id)

        if (nav) {
            nav.toggle()
        }
    }
}